/** Full calendar year period (year is selected in the separate year dropdown). */
export const ZM_ELSTER_PERIOD_YEAR = "YEAR";
